import { render } from "./TheNhaXe.vue?vue&type=template&id=cbb49f20"
import script from "./TheNhaXe.vue?vue&type=script&lang=js"
export * from "./TheNhaXe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__